import { useState, forwardRef, useImperativeHandle } from 'react';
import { Typography, DateRangePicker } from "@volvo/vcdk-react";
import { DateRangePickerChangeEvent } from '@volvo/vcdk';

export const DateCard = forwardRef((props, ref) => {

    const today = new Date();
    const [dateRange, setDateRange] = useState<{ start: Date | null; end: Date | null }>({start: today, end: today});
    const [valid, setValid] = useState(true);

    useImperativeHandle(ref, () => ({
        getDateRange: () => {
            let startDate = dateRange.start, endDate = dateRange.end;
            if(!startDate || !endDate) setValid(false);
            return {
                startDate: `${startDate?.getFullYear()}-${(startDate?.getMonth()! + 1).toString().padStart(2, '0')}-${startDate?.getDate().toString().padStart(2, '0')}`, 
                endDate: `${endDate?.getFullYear()}-${(endDate?.getMonth()! + 1).toString().padStart(2, '0')}-${endDate?.getDate().toString().padStart(2, '0')}`
            };
        }
    }));

    return (
        <div style={{ border: '1px solid #E1E1E1', borderRadius: 8, padding: 20, backgroundColor: '#F7F7F7', gap: 8, display: 'grid', height:128 }}>
            <Typography variant='subtitle1' style={{ color: valid ? 'inherit' : '#BF2012' }}>Invoicing period</Typography>
            <DateRangePicker onDateRangeChange={(e: DateRangePickerChangeEvent ) => {
                setValid(true);
                setDateRange({ start: e.detail.start, end: e.detail.end });
            }} start-label="From" format='yyyy-MM' end-label="To" size="small" />
        </div>
    );
});